// Copyright (c) 2017 Deere & Company

import * as helpers from './helpers';
import React, {
    PropTypes,
    PureComponent
} from 'react';
import Accordion from '../../../../shared/components/accordion';
import {Checkbox} from 'cap-it-ui.toggles';
import DealerHierarchyCities from './dealer-hierarchy-cities';

class DealerHierarchyLeadAccounts extends PureComponent {

    handleAccountChange = selectedLeadAccount => accountChanges => {

        this.props.onAccountChange({
            ...accountChanges,
            selectedLeadAccount
        });

    };

    handleCityChange = selectedLeadAccount => cityChanges => {

        this.props.onCityChange({
            ...cityChanges,
            selectedLeadAccount
        });

    };

    handleLeadAccountChange = leadAccount => () => {

        const selectedLeadAccount = leadAccount.dealer.account;
        const selectedLeadAccounts = helpers.updateSelectionMap(this.props.selectedLeadAccounts, selectedLeadAccount);

        this.props.onLeadAccountChange({
            leadAccount,
            selectedLeadAccount,
            selectedLeadAccounts
        });

    };

    render() {

        return (
            <ul className='lead-accounts'>
                {this.props.leadAccounts.map((leadAccount, leadAccountIndex) =>
                    <li key={leadAccountIndex}>
                        <Accordion
                            accordionId={`${leadAccount.id}-${leadAccountIndex}`}
                            body={
                                <DealerHierarchyCities
                                    cities={leadAccount.cities}
                                    onAccountChange={this.handleAccountChange(leadAccount.dealer.account)}
                                    onCityChange={this.handleCityChange(leadAccount.dealer.account)}
                                    selectedAccounts={this.props.selectedAccounts}
                                    selectedCities={this.props.selectedCities}
                                />
                            }
                            title={
                                <Checkbox
                                    id={`${leadAccount.id}-${leadAccountIndex}`}
                                    onChange={this.handleLeadAccountChange(leadAccount)}
                                    selected={this.props.selectedLeadAccounts[leadAccount.dealer.account]}
                                >
                                    {leadAccount.dealer.name}
                                </Checkbox>
                            }
                        />
                    </li>
                )}
            </ul>
        );

    }

}

DealerHierarchyLeadAccounts.displayName = 'DealerHierarchyLeadAccounts';
DealerHierarchyLeadAccounts.propTypes = {
    leadAccounts: PropTypes.array.isRequired,
    onAccountChange: PropTypes.func.isRequired,
    onCityChange: PropTypes.func.isRequired,
    onLeadAccountChange: PropTypes.func.isRequired,
    selectedAccounts: PropTypes.object.isRequired,
    selectedCities: PropTypes.object.isRequired,
    selectedLeadAccounts: PropTypes.object.isRequired
};

export default DealerHierarchyLeadAccounts;



// WEBPACK FOOTER //
// ./src/tcsm/audits/components/audit-dealer-hierarchy/dealer-hierarchy-lead-accounts.js